import {
  AvailableMainProductTrialType,
  AvailableSecondaryProductTrialType,
} from '../../types/AvailableProductTrialType';

export interface CardItem {
  type: AvailableSecondaryProductTrialType;
  cardName: string;
  text: string;
  icon: string;
  buttonText: string;
  buttonId: string;
  tagInformation?: string;
  canBuy?: boolean;
}

export interface ProductItem {
  type: AvailableMainProductTrialType;
  title: string;
  description: string;
  buttonText: string;
  buttonId: string;
  imageSrc: string;
}

export enum HomePageEventsName {
  PRODUCT_ITEM = 'homePageProductItemClick',
}
